import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import ProfileSection from './ProfileSection';
import PreferencesSection from './PreferencesSection';
import BillingSection from './BillingSection';

const NAV_ITEMS = [
  { key: 'profile', label: 'Profile' },
  { key: 'preferences', label: 'Preferences' },
  { key: 'billing', label: 'Billing' },
];

function mapStateToProps(state) {
  return { userInfo: state.userInfo };
}

function Settings({ user, userInfo }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const sectionParam = searchParams.get('section');
  const activeSection = NAV_ITEMS.some(i => i.key === sectionParam) ? sectionParam : 'profile';

  function navigate(key) {
    setSearchParams({ section: key });
  }

  return (
    <Container className="py-4">
      <Row>
        <Col xs={12} md={3} className="mb-4 mb-md-0">
          <nav className="settings-nav">
            <p className="settings-nav-header">Account</p>
            {NAV_ITEMS.map(item => (
              <button
                key={item.key}
                className={`settings-nav-item${activeSection === item.key ? ' active' : ''}`}
                onClick={() => navigate(item.key)}
              >
                {item.label}
              </button>
            ))}
            <div className="mt-4">
              <p className="settings-nav-header">Help</p>
              <a
                href="mailto:support@moneyplant.world"
                className="settings-nav-item d-block text-decoration-none"
              >
                Contact Support
              </a>
            </div>
          </nav>
        </Col>
        <Col xs={12} md={9}>
          {activeSection === 'profile' && <ProfileSection user={user} />}
          {activeSection === 'preferences' && <PreferencesSection userInfo={userInfo} />}
          {activeSection === 'billing' && <BillingSection />}
        </Col>
      </Row>
    </Container>
  );
}

export default connect(mapStateToProps)(Settings);
